import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, ArrowRightIcon } from 'lucide-react';
const services = ['Ring sizing', 'Claw tip repairs', 'Re-shanking', 'Chain & bracelet repairs', 'Clasps & safety chains', 'Polishing & rhodium plating', 'Heirloom remodelling', 'Stone re-setting', 'Insurance valuations', 'Pearl restringing', 'Engraving', '3D proof redesign'];
export function Repairs() {
  return <section id="repairs" className="section-padding bg-surface border-y border-gold/15" data-id="element-549">
      <div className="container-custom" data-id="element-550">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start mb-16" data-id="element-551">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="lg:col-span-7" data-id="element-552">
            <span className="eyebrow" data-id="element-553">Repairs · Remodelling · Restoration</span>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium leading-[1.1] mb-7 text-balance" data-id="element-554">
              Some pieces are worth more than their metal and stones.{' '}
              <span className="italic text-gold-dark" data-id="element-555">
                We treat them that way.
              </span>
            </h2>

            <p className="text-secondary text-lg leading-relaxed mb-8 text-pretty max-w-2xl" data-id="element-556">
              We've re-sized rings for the third time in sixty years. We've
              melted down jewellery boxes' worth of inherited gold into a single
              piece a granddaughter will wear forever. The sentimental work is
              the work we love most.
            </p>

            <div className="grid grid-cols-2 gap-x-6 gap-y-2.5 mb-10 max-w-xl" data-id="element-557">
              {services.map((service, index) => <div key={index} className="flex items-center gap-2.5 border-b border-paper-deep pb-2.5" data-id="element-558">
                  <span className="w-1 h-1 bg-gold rounded-full shrink-0" data-id="element-559" />
                  <span className="text-sm text-primary" data-id="element-560">{service}</span>
                </div>)}
            </div>

            <div className="flex flex-wrap gap-3 items-center" data-id="element-561">
              <a href="#consultation" className="btn-primary group" data-id="element-562">
                Ask about a repair or remodel
                <ArrowRightIcon className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" data-id="element-563" />
              </a>
              <div className="inline-flex items-center gap-2 px-4 py-3 text-sm text-secondary bg-paper" data-id="element-564">
                <ClockIcon className="w-4 h-4 text-gold-dark" data-id="element-565" />
                Most repairs returned within{' '}
                <strong className="text-primary mx-1" data-id="element-566">7 days</strong>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.9
        }} className="lg:col-span-5" data-id="element-567">
            <div className="relative aspect-square w-full max-w-md mx-auto rounded-full overflow-hidden border-[6px] border-paper shadow-[0_20px_50px_-10px_rgba(31,27,23,0.2)]" data-id="element-568">
              <img src="https://cdn.magicpatterns.com/uploads/iPJgC3uU24qy6g4DSNZ3QQ/sn2.webp" alt="A jeweller restoring a sentimental piece at the Sinclairs Ardross workshop" className="absolute inset-0 w-full h-full object-cover" data-id="element-569" />
            </div>
            <p className="text-center mt-6 font-serif italic text-lg text-secondary max-w-sm mx-auto leading-snug text-pretty" data-id="element-570">
              "Bring us your mother's ring. We'll handle it the way she would
              have wanted."
            </p>
          </motion.div>
        </div>

        {/* Heirloom callout */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-burgundy text-white p-8 md:p-10 grid md:grid-cols-[1fr_auto] gap-8 items-center relative overflow-hidden" data-id="element-571">
          <div className="absolute inset-0 opacity-[0.05]" style={{
          backgroundImage: 'radial-gradient(rgba(255,255,255,0.4) 1px, transparent 1px)',
          backgroundSize: '20px 20px'
        }} data-id="element-572" />
          <div className="relative" data-id="element-573">
            <p className="eyebrow-light text-gold-light" data-id="element-574">
              Heirloom remodelling
            </p>
            <p className="font-serif text-xl md:text-2xl text-white leading-snug mb-2" data-id="element-575">
              Inherited gold. Inherited stones. A piece nobody else has worn.
            </p>
            <p className="text-sm text-white/80 leading-relaxed max-w-2xl" data-id="element-576">
              Most heirloom remodels are completed in 4–6 weeks. We'll talk
              through what's possible, what can be reused, and what the finished
              piece could look like — at no cost, with no obligation.
            </p>
          </div>
          <a href="#consultation" className="btn-gold relative shrink-0" data-id="element-577">
            Book a remodel chat
          </a>
        </motion.div>
      </div>
    </section>;
}